import LoginTab from "./login-tab";
import { ILoginProps } from "./login-props";
import { useTranslation } from "react-i18next";
import ForgotTab from "./forgot-tab";
import ResetTab from "./reset-tab";

export default function Login({
  activeTab,
  loginAlert,
  forgotAlert,
  resetAlert,
  customerType,
  username,
  password,
  onActiveTabChange,
  onUsernameChange,
  onPasswordChange,
  onCustomerTypeToggle,
  onLogin,
  onResetPassword,
  onForgotPassword,
}: ILoginProps) {
  const { t } = useTranslation();

  const handleCustomerTypeToggle = () => {
    onCustomerTypeToggle();
    onUsernameChange("");
    onPasswordChange("");
    onActiveTabChange("login");
  };

  return (
    <div className="container mt-5 mx-auto">
      <div className="sign-section xs:p-10 lg:p-10 xl:p-20 p-20 rounded-xl pb-6">
        <div className="top-nav-section flex sm:flex-row sm:justify-between sm:items-center justify-between flex-row-reverse sm:flex-row">
          <a
            href="https://sepanta.com"
            className="login-logo mx-1 text-grey-d3 items-center flex mb-4 sm:mb-0"
          >
            <img
              alt="logo"
              className="logo w-20 sm:w-28 mr-auto sm:mr-0"
              src="https://c.sepanta.com/i1/Logos/SepantaLogo.png"
            />
            <span className="mainTitle hidden sm:inline">سپنتا</span>
          </a>
        </div>

        <div className="lg:w-2/2 md:w-2/4 xl:w-2/6 mx-auto xs:p-0 p-10">
          {activeTab === "login" && (
            <LoginTab
              alert={loginAlert}
              forgotAlert={forgotAlert}
              customerType={customerType}
              handleLogin={onLogin}
              password={password}
              username={username}
              setActiveTab={onActiveTabChange}
              setUsername={onUsernameChange}
              setPassword={onPasswordChange}
              handleContinue={onForgotPassword}
            />
          )}

          {activeTab === "forgot" && (
            <ForgotTab
              alert={forgotAlert}
              customerType={customerType}
              username={username}
              setActiveTab={onActiveTabChange}
              setUsername={onUsernameChange}
              handleContinue={onForgotPassword}
              toggle={false}
              handleToggle={() => {}}
            />
          )}

          {activeTab === "reset" && (
            <ResetTab
              alert={resetAlert}
              username={username}
              password={password}
              setActiveTab={onActiveTabChange}
              setPassword={onPasswordChange}
              handleContinue={onResetPassword}
            />
          )}

          <div className="form-section rtl flex flex-col gap-4 justify-between pb-10">
            <button
              onClick={handleCustomerTypeToggle}
              className="signup-google-btn p-5 mt-4 flex text-center justify-center"
            >
              {t(`Login.ChangeButton.${customerType}`)}
              <span className="sepanta-icon-left-long-arrow"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
